import { createSelector } from '@ngrx/store';
import { getProgressSearchSpinner } from 'src/app/shared/selectors/progress.selectors';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getFlowConfigurationState = createSelector(
  getDragonflyState,
  (state) => state.flowsConfiguration,
);

export const getContextFlowValues = createSelector(
  getFlowConfigurationState,
  ({ contextFlowValues }) => contextFlowValues,
);

export const getContextFlow = createSelector(
  getFlowConfigurationState,
  ({ contextFlow }) => contextFlow,
);

export const getFlowEventValues = createSelector(
  getFlowConfigurationState,
  ({ flowEventValues }) => flowEventValues,
);

export const getFlowEvent = createSelector(getFlowConfigurationState, ({ flowEvent }) => flowEvent);

export const getRenderFlowEvent = createSelector(
  getFlowEventValues,
  getContextFlow,
  (flowEventValues, contextFlow) => flowEventValues.length > 0 && !!contextFlow,
);

export const getRenderEditFlowEvent = createSelector(
  getFlowEvent,
  getProgressSearchSpinner,
  (flowEvent, progressSearchSpinner) => !progressSearchSpinner && !!flowEvent,
);

export const getDisplayedColumns = createSelector(
  getFlowConfigurationState,
  ({ displayedColumns }) => displayedColumns,
);

export const getDisplayedColumnKeys = createSelector(
  getFlowConfigurationState,
  ({ displayedColumns }) => Object.keys(displayedColumns),
);

export const getFlowTable = createSelector(getFlowConfigurationState, ({ flowTable }) => flowTable);

export const getFlowTableExists = createSelector(
  getFlowConfigurationState,
  ({ flowTable }) => flowTable.length > 0,
);

export const getDragEnabled = createSelector(
  getFlowConfigurationState,
  ({ dragEnabled }) => !dragEnabled,
);

export const getAddFlow = createSelector(getFlowConfigurationState, ({ addFlow }) => addFlow);

export const getAddFlowFiltered = createSelector(getAddFlow, getFlowTable, (addFlow, flowTable) => {
  const flowIds = new Set(flowTable.map((flow) => flow.flowID).filter((id): id is string => !!id));

  return addFlow.filter((flow) => !flowIds.has(flow.flowId));
});

export const getAddFlowEmpty = createSelector(
  getAddFlowFiltered,
  (addFlowFiltered) => addFlowFiltered.length === 0,
);

export const getUserSubmitted = createSelector(
  getFlowConfigurationState,
  ({ userSubmitted }) => userSubmitted,
);

export const getManageRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('flow.event.action.manage'),
);

export const getNoManageRole = createSelector(
  getRoles,
  (roles) => !Object.keys(roles).includes('flow.event.action.manage'),
);

export const getDisableUpdate = createSelector(
  getFlowTable,
  getManageRole,
  (flowTable, manageRole) =>
    flowTable.some((flow) => new Date(flow.activeFrom) > new Date(flow.activeUntil)) || !manageRole,
);
